module.exports = __webpack_public_path__ + "static/media/logo-white.b7616ec9.svg";